export const initialState = {
  isModalOpen: false,
  platformsFilter: null,
  sourcesSubtypesFilter: null,
  countriesFilter: null,
  countriesExcludeFilter: false,
  sourcesTypesFilter: null,
  affiliationCountryId: null,
  affiliationCountriesExcludeFilter: false,
  affiliationTypesFilter: null,
  affiliationTypesExcludeFilter: false,
  highRiskExcludeFilter: false,
  botsExcludeFilter: false,
  audienceFilter: null,
  sourceGroupFilter: null,
  tagsFilter: null,
  sourceFilter: null,
  widgetName: null,
  modalTitle: null,
  stateAffiliated: null,
  highRisk: null,
  inauthenticBehavior: null,
}


const breakdownsReducer = (state=initialState, action) => {

  switch (action.type) {

    case 'OPEN_MODAL':
      return Object.assign({}, state, {
        isModalOpen: true
      })
    case 'CLOSE_MODAL':
      return Object.assign({}, state, {
        isModalOpen: false,
        platformsFilter: null,
        sourcesSubtypesFilter: null,
        countriesFilter: null,
        countriesExcludeFilter: false,
        sourcesTypesFilter: null,
        affiliationCountryId: null,
        affiliationCountriesExcludeFilter: false,
        affiliationTypesFilter: null,
        affiliationTypesExcludeFilter: false,
        highRiskExcludeFilter: false,
        botsExcludeFilter: false,
        audienceFilter: null,
        sourceGroupFilter: null,
        tagsFilter: null,
        sourceFilter: null,
        widgetName: null,
        modalTitle: null,
      })
      
    case 'SET_PLATFORMS_FILTER':
      return Object.assign({}, state, {
        platformsFilter: action.platformsFilter
      })

    case 'SET_COUNTRIES_FILTER': 
      return Object.assign({}, state, {
        countriesFilter: action.countriesFilter
      })

    case 'SET_COUNTRIES_EXCLUDE_FILTER':
      return Object.assign({}, state, {
        countriesExcludeFilter: action.countriesExcludeFilter
      })

    case 'SET_TYPES_FILTER':
      return Object.assign({}, state, {
        sourcesTypesFilter: action.typesFilter
      })

    case 'SET_SUBTYPES_FILTER': 
      return Object.assign({}, state, {
        sourcesSubtypesFilter: action.subtypesFilter
      })
    
    case 'SET_AFFILIATION_COUNTRY_ID':
      return Object.assign({}, state, {
        affiliationCountryId: action.countryId
      })

    case 'SET_AFFILIATION_COUNTRIES_EXCLUDE_FILTER':
      return Object.assign({}, state, {
        affiliationCountriesExcludeFilter: action.affiliationExcludeFilter
      })

    case 'SET_AFFILIATION_TYPES_FILTER':
      return Object.assign({}, state, {
        affiliationTypesFilter: action.affiliationTypesFilter
      })

    case 'SET_AFFILIATION_TYPES_EXCLUDE_FILTER':
      return Object.assign({}, state, {
        affiliationTypesExcludeFilter: action.affiliationTypesExcludeFilter
      })

    case 'SET_HIGH_RISK_EXCLUDE_FILTER':
      return Object.assign({}, state, {
        highRiskExcludeFilter: action.highRiskExcludeFilter
      })

    case 'SET_BOTS_EXCLUDE_FILTER':
      return Object.assign({}, state, {
        botsExcludeFilter: action.botsExcludeFilter
      })

    case 'SET_AUDIENCE_FILTER':
      return Object.assign({}, state, {
        audienceFilter: action.audienceRange
      })

    case 'SET_SOURCE_GROUP_FILTER':
      return Object.assign({}, state, {
        sourceGroupFilter: action.sourceGroupId
      })

    case 'SET_TAGS_FILTER':
      return Object.assign({}, state, {
        tagsFilter: action.tagsFilter
      })

    case 'SET_SOURCE_FILTER':
      return Object.assign({}, state, {
        sourceFilter: action.sourceId
      })
    case 'SET_CURRENT_WIDGET_NAME':
      return Object.assign({}, state, {
        widgetName: action.widgetName
      })
    case 'SET_MODAL_TITLE':
      return Object.assign({}, state, {
        modalTitle: action.modalTitle
      })
    case 'SET_STATE_AFFILIATED':
      return Object.assign({}, state, {
        stateAffiliated: action.stateAffiliated
      })
    case 'SET_HIGH_RISK':
      return Object.assign({}, state, {
        highRisk: action.highRisk
      })
    case 'SET_INAUTHENTIC_BEHAVIOR':
      return Object.assign({}, state, {
        inauthenticBehavior: action.inauthenticBehavior
      })
    default: 
      return state;
  }
}

export default breakdownsReducer;
